import { render, staticRenderFns } from "./ProgramEventItem.vue?vue&type=template&id=1900b61b&scoped=true&"
import script from "./ProgramEventItem.vue?vue&type=script&lang=js&"
export * from "./ProgramEventItem.vue?vue&type=script&lang=js&"
import style0 from "./ProgramEventItem.vue?vue&type=style&index=0&id=1900b61b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1900b61b",
  null
  
)

export default component.exports